import { Skeleton, message } from 'antd';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import Title from 'pages/common/components/title/Title';
import AuctionForm from './components/AuctionForm/AuctionForm';

import { fetchAuction } from 'apis/auction';
import { initAuctionFormState, resetAuctionFormState } from 'features/auctionFormSlice';
import useAppSelector from 'hooks/useAppSelector';
import useNavigateToPrev from 'hooks/useNavigateToPrev';
import { redirectToLoginPage } from 'utils';

import styles from './CreateAuction.module.css';

function EditAuction() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const navigateToPrev = useNavigateToPrev();
  const { auctionId } = useParams();

  const [isCreated, setIsCreated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const { authenticated, loginUser } = useAppSelector((state) => state.user);

  useEffect(() => {
    if (!authenticated) {
      message.info('로그인이 필요한 페이지입니다.');
      redirectToLoginPage(navigate);
    } else {
      dispatch(resetAuctionFormState());

      fetchAuction(auctionId)
        .then((auction) => {
          if (loginUser?.id !== auction.seller.id) {
            message.error('경매 수정 권한이 없습니다.');
            navigateToPrev();
          } else if (auction.state !== 'draft') {
            message.error('수정 불가능한 경매입니다.');
            navigateToPrev();
          }

          dispatch(initAuctionFormState(auction));
          setIsLoading(false);
        })
        .catch((errMsg) => {
          if (errMsg) message.error(errMsg);
          navigateToPrev();
        });
    }
  }, [auctionId, authenticated, loginUser?.id]);

  useEffect(() => {
    if (isCreated) {
      dispatch(resetAuctionFormState());
      navigate(`/auctions/${auctionId}`);
    }
  }, [auctionId, dispatch, isCreated, navigate]);

  const closeAuctionForm = () => setIsCreated(true);

  return (
    <div>
      <Title className={styles.title} level={1}>
        상품수정
      </Title>
      {isLoading ? <Skeleton active /> : <AuctionForm closeAuctionForm={closeAuctionForm} />}
    </div>
  );
}

export default EditAuction;
